<template>
  <div class="payment-redirect-page app-page">
    <div class="redirect-card">
      <div v-if="isLoading" class="loading-state">
        <div class="loader"></div>
        <h2>正在加载支付信息</h2>
        <p>请稍候，即将跳转至支付页面...</p>
      </div>

      <!-- 使用iframe加载表单 -->
      <iframe
        v-else
        ref="paymentIframe"
        frameborder="0"
        width="100%"
        :height="iframeHeight"
        class="payment-iframe"
      ></iframe>

      <div v-if="error" class="error-state">
        <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="#f56c6c" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
        <h3>加载失败</h3>
        <p>{{ error }}</p>
        <el-button type="primary" @click="loadPaymentForm" class="retry-btn">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 102.13-9.36L1 10"/></svg>
          重新加载
        </el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';

const route = useRoute();
const paymentIframe = ref(null);
const isLoading = ref(true);
const error = ref('');
const iframeHeight = ref('1200px');
const orderNo = route.query.orderNo;

const loadPaymentForm = async () => {
  if (!orderNo) {
    error.value = '未获取到订单号';
    isLoading.value = false;
    return;
  }

  try {
    isLoading.value = true;
    error.value = '';
    const response = await axios.get(`/pay-service/qrcode/${orderNo}`);
    const payFormHtml = response.data.data; // 直接使用原始HTML，不进行解码
    console.log(payFormHtml);

    if (!payFormHtml) {
      error.value = '未获取到支付信息';
      isLoading.value = false;
      return;
    }

    isLoading.value = false;

    nextTick(() => {
      if (!paymentIframe.value) {
        error.value = '支付表单加载失败';
        return;
      }
      const iframeDoc = paymentIframe.value.contentDocument;
      iframeDoc.open();
      iframeDoc.write(payFormHtml); // 直接写入原始HTML
      iframeDoc.close();
    });
  } catch (err) {
    error.value = '获取支付信息失败：' + (err.message || '网络错误');
    isLoading.value = false;
  }
};

onMounted(() => {
  loadPaymentForm();
});
</script>

<style scoped>
.payment-redirect-page {
  max-width: 800px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 40px;
}

.redirect-card {
  width: 100%;
  background: var(--app-bg-card);
  border-radius: var(--app-radius-xl);
  box-shadow: var(--app-shadow-card);
  border: 1px solid var(--app-border-subtle);
  overflow: hidden;
  min-height: 500px;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
}

.loader {
  width: 48px;
  height: 48px;
  border: 4px solid var(--app-border-light);
  border-top-color: var(--app-color-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 24px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-state h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0 0 8px;
}

.loading-state p {
  color: var(--app-text-secondary);
  font-size: 0.9375rem;
  margin: 0;
}

.payment-iframe {
  border: none;
  border-radius: 0 0 var(--app-radius-xl) var(--app-radius-xl);
  display: block;
}

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
}

.error-state h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 16px 0 8px;
}

.error-state p {
  color: var(--app-text-secondary);
  font-size: 0.9375rem;
  margin: 0 0 24px;
  max-width: 400px;
}

.retry-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: var(--app-radius-lg) !important;
  padding: 12px 28px !important;
}
</style>
